module.exports = __webpack_public_path__ + "static/media/kissing-face-with-smiling-eyes-svgrepo-com.31e397f7.svg";